<button mat-button [matMenuTriggerFor]="Notification" aria-label="mode" class="header-item">
    <a href="javascript:" class="pc-head-link badge-on-button" [matBadge]="unReadCount || ''" matBadgeColor="primary"
        matBadgeOverlap="false" style="color: inherit;">
        <svg class="pc-icon">
            <use xlink:href="assets/fonts/custom-icon.svg#custom-notification"></use>
        </svg>
    </a>
</button>
<mat-menu #Notification="matMenu" [xPosition]="currentLang ==='ar'? 'after' : 'before'" class="dropdown-notification">
    <div class="dropdown-header flex align-item-center justify-content-between">
        <div class="f-w-600 f-16 text-capitalize"> {{'notification' |translate}}</div>
        <a href="javascript:" class="mat-body text-primary-500" (click)="markAllAsRead($event)">
            {{'markAllAsRead'|translate}}
        </a>
    </div>

    <mat-button-toggle-group appearance="legacy" name="fontStyle" aria-label="Font Style"
        class="flex justify-content-center align-item-center pb-3" style="box-shadow: none; overflow: visible;"
        [(value)]="selectedTab" (click)="$event.stopPropagation()">
        <mat-button-toggle value="unRead" (click)="showUnRead()">
            <span class="mx-2">{{'unRead' | translate}}</span>
        </mat-button-toggle>

        <mat-button-toggle value="allNotifications" (click)="showAll()">
            <span class="mx-2">{{'allNotifications' | translate}}</span>
        </mat-button-toggle>
    </mat-button-toggle-group>
    <ng-scrollbar style="height: calc(100vh - 215px)" visibility="hover" #scrollbar>
        <div class="dropdown-body">
            <!-- <div class="m-b-10 mat-body f-w-500 text-capitalize">{{'today' |translate}}</div> -->
            @for (card of selectedTab === 'unRead' ? unReadNotifications : allNotifications; track card) {
            <app-card [showHeader]="false" [cardClass]="'notification-card m-b-10' + (card.isread ? '' : ' unRead')"
                padding="16" (click)="notifyClicked($event, card)">
                <div class="flex">
                    <div class="topic-icon flex-shrink-0">
                        <svg class="pc-icon text-primary-500">
                            <use attr.xlink:href="assets/fonts/custom-icon.svg#{{card.icon}}"></use>
                        </svg>
                    </div>
                    <div class="topic-description flex-grow-1 m-l-15">
                        <!-- <span class="mat-caption float-end text-muted">{{ card.time }}</span> -->
                        <div class="m-b-10 mat-body f-w-600">{{ card.title |translate}}</div>
                        <p class="m-b-0 mat-body">{{ card.description | translate : ({ count: unReadCount })
                            }}</p>
                    </div>
                </div>
            </app-card>
            }
            @empty {
            <div (click)="$event.stopPropagation()" class="w-100 flex align-items-center justify-content-center"
                style="height: calc(100vh - 215px)">
                <p class="m-b-0 mat-body text-capitalize f-w-500 p-3">
                    {{'noNotify' | translate}}</p>
            </div>
            }

        </div>
    </ng-scrollbar>
</mat-menu>